import {  Component           ,
          EventEmitter        ,
          Input               ,
          Output              } from "@angular/core";
import {  ReactiveFormsModule } from "@angular/forms";
import {  SidebarModule       } from 'primeng/sidebar';
import {  FileUploadModule    } from 'primeng/fileupload';

import {  TranslatePipe       } from "nv@services/translate.service";

@Component({
  selector    : 'template-import-excel-report',
  templateUrl : './template-import.component.html',
  imports     : [
    ReactiveFormsModule ,
    SidebarModule       ,
    TranslatePipe       ,
    FileUploadModule
  ]
})
export class TemplateImportExcelReport {

  @Input()  public $form: any;
  @Output() public onUpload = new EventEmitter();

  /**
   * Downloads the Excel template for PDF report generation
   */
  public downloadTemplate() {
    window.location.href = '/assets/import_templates/import_site_report.xlsx';
  }

  public processEmit($event: any, $fu: any) {

    this.onUpload.emit($event);
    $fu.clear();
  }
}
